import { useVariant } from '@calendly/feature-check-react'

const GETTING_STARTED_GUIDE_REMOVAL_EXPERIMENT_KEY = 'growth_getting_started_guide_removal'
const GETTING_STARTED_GUIDE_REMOVAL_SESSION_KEY = 'growth_getting_started_guide_removal_variant'

const GETTING_STARTED_GUIDE_REMOVAL_VARIANTS = {
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
}

const KNOWN_VARIANTS = new Set([
  'control',
  GETTING_STARTED_GUIDE_REMOVAL_VARIANTS.VARIANT_1,
  GETTING_STARTED_GUIDE_REMOVAL_VARIANTS.VARIANT_2,
])

const readStickyVariant = () => {
  try {
    return sessionStorage.getItem(GETTING_STARTED_GUIDE_REMOVAL_SESSION_KEY)
  } catch (error) {
    return null
  }
}

const writeStickyVariant = (variant) => {
  try {
    sessionStorage.setItem(GETTING_STARTED_GUIDE_REMOVAL_SESSION_KEY, variant)
  } catch (error) {
    // Ignore quota / private-mode failures; bootstrap value still applies.
  }
}

/** @param {boolean} [isTracked=false] Pass true only from the single exposure owner. */
export const useGettingStartedGuideRemovalVariant = (isTracked = false) => {
  const variant = useVariant(GETTING_STARTED_GUIDE_REMOVAL_EXPERIMENT_KEY, isTracked)

  // Explicit holdout — do not fall back to a prior sticky assignment.
  if (variant === null) return null

  if (KNOWN_VARIANTS.has(variant)) {
    writeStickyVariant(variant)
    return variant
  }

  // Bootstrap can briefly omit the key on refresh; keep the last known assignment so
  // variant_2 does not flicker the floating button back on.
  const stickyVariant = readStickyVariant()
  return KNOWN_VARIANTS.has(stickyVariant) ? stickyVariant : variant
}

const isGettingStartedGuideMinimized = (variant) => (
  variant === GETTING_STARTED_GUIDE_REMOVAL_VARIANTS.VARIANT_1
)

export const isGettingStartedGuideRemoved = (variant) => (
  variant === GETTING_STARTED_GUIDE_REMOVAL_VARIANTS.VARIANT_2
)

export const shouldSuppressGettingStartedAutoOpen = (variant) => {
  // Explicit holdout is null. Missing experiment key is undefined and should keep
  // legacy trial auto-open until the experiment is configured in bootstrap.
  if (variant === null) return true

  return isGettingStartedGuideMinimized(variant) || isGettingStartedGuideRemoved(variant)
}

export const shouldShowGettingStartedHelpEntry = ({
  viewable,
  open,
  dismissed,
  variant,
}) => (
  Boolean(viewable)
  && !open
  && (dismissed || isGettingStartedGuideRemoved(variant))
)
